/*
 * Determine the env
 */
function determineEnv() {
  window.env = 'local';
  if (window.location.hostname.indexOf('findyourzo') > - 1) {
    if (window.location.hostname.indexOf('dev') > - 1) {
      window.env = 'dev';
    } else if (window.location.hostname.indexOf('staging') > - 1) {
      window.env = 'staging';
    } else {
      window.env = 'prod';
    }
  }
}

// Init carousel
function initHomepage() {
  $('.carousel').on('init', (event, slick) => {
    $('.carousel').addClass('initialized');
  });
  $('.carousel').on("afterChange", (e, slick) => {
    if (slick.currentSlide === 0) {
      $('.carousel').slick("setOption", "autoplaySpeed", 12000);
    } else {
      $('.carousel').slick("setOption", "autoplaySpeed", 4000);
    }
  });
  $('.carousel').slick({
    autoplay: true,
    autoplaySpeed: 12000,
    infinite: true,
    slidesToShow: 1,
    draggable: true,
    fade: true,
    pauseOnHover: false,
    arrows: false,
    speed: 3000
  });

  $('header a').click(() => {
    $('.carousel').slick('slickGoTo', 0, true);
    $('html, body').animate({
      scrollTop: $('#intro').offset().top
    }, 800);
  });

  // Carousel inview
  const inview = new Waypoint.Inview({
    element: $('.carousel'),
    enter: (direction) => {
      $('body').removeClass('carousel-out-of-view');
      $('.down-carrot').fadeIn();
    },
    entered: (direction) => {},
    exited: (direction) => {
      $('body').addClass('carousel-out-of-view');
      $('.down-carrot').fadeOut();
    },
  });

  function toggleActiveClasses(className) {
    $('.carousel-out-of-view').removeClass((index, css) => (
      (css.match(/(^|\s)active-\S+/g) || []).join(' ')
    ));
    $('nav a').removeClass('active');
    $('.carousel-out-of-view').addClass('active-' + className);
    $('nav a[href="#' + className + '"]').addClass('active');
  }

  // Account for down scroll
  $('.panel').each(function () {
    $(this).waypoint(function (direction) {
      if (direction == 'down') {
        toggleActiveClasses(this.element.id);
      }
    }, {
      offset: '50%'
    });
  });

  // Account for up scroll
  $('.panel').each(function () {
    $(this).waypoint(function (direction) {
      if (direction == 'up') {
        toggleActiveClasses(this.element.id);
      }
    }, {
      offset: '-50%'
    });
  });

  // Smooth scroll
  $(() => {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        let target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 800);
          return false;
        }
      }
    });
  });
}

function activateNav() {
  $('.generic-sidebar .' + window.location.pathname.split('/')[1] + '-nav').addClass('active');
}

/*
 * Init GA on dev or prod only
 */
function initGa() {
  if (window.env === 'prod') {
    (function(i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      i[r] = i[r] || function() {
          (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date();
      a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    ga('create', 'UA-90034128-1', 'auto');
    ga('set', 'anonymizeIp', true);
    fireGAEvent('send', 'pageview');
  }
}

function fireGAEvent(arg1, arg2, arg3, arg4, arg5, arg6) {
  if (window.env === 'prod') {
    ga(arg1, arg2, arg3, arg4, arg5, arg6);
  }
}

function trackOutboundLink(url, action) {
  if (window.env === 'prod' && ga && ga.create) {
    ga('send', 'event', 'outbound', 'click', url, {
      transport: 'beacon',
      hitCallback: () => { document.location = url; }
    });
  } else {
    document.location = url;
  }
}

function initContact() {
  document.getElementById('campus-info').classList.remove('no-js');
  const select = document.getElementById('campus-select');

  function updateCurrentContact() {
    const id = select.value;
    for (const li of document.querySelectorAll('#campus-contacts > li')) {
      li.classList.toggle('is-active', li.dataset.contactId === id);
    }
  }

  select.addEventListener('change', updateCurrentContact);
  updateCurrentContact();
}
